import { render, staticRenderFns } from "./BreadcrumbSep.vue?vue&type=template&id=b4e1c60e&scoped=true&"
import script from "./BreadcrumbSep.vue?vue&type=script&lang=ts&"
export * from "./BreadcrumbSep.vue?vue&type=script&lang=ts&"
import style0 from "./BreadcrumbSep.vue?vue&type=style&index=0&id=b4e1c60e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e1c60e",
  null
  
)

export default component.exports